module.exports = __webpack_public_path__ + "dc1e0921b497238573e99bb039d8ca5a.dcm";